import { SiloConfiguration } from '@silo/config-legacy';
import { DecoratedSilo, SiloAsset, getIsBorrowableAsset, getIsNonCollateral } from '../../../queries/decoratedSilo';
import { and } from '@silo/utils';
import { getConfigDepositMode } from '@silo/config';
import { makeAddressSync, ProtocolKey } from '@silo/types';

/**
 * Get assets that should be displayed in the borrow dropdown
 */
export const getAssetsToDisplay = (
  protocolKey: ProtocolKey,
  siloConfig: SiloConfiguration,
  decoratedSilo: DecoratedSilo
) => {
  const marketAddress = makeAddressSync(decoratedSilo.siloAddress);

  const getIsNotProtectedDepositsOnly = ({ assetKey }: SiloAsset) =>
    getConfigDepositMode({ protocolKey, marketAddress, assetKey }) !== 'protectedOnly';

  const shouldDisplayAsset = and(getIsNonCollateral, getIsNotProtectedDepositsOnly, getIsBorrowableAsset(siloConfig));

  return decoratedSilo.assets.filter(shouldDisplayAsset);
};
